import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('tenants')

export const FETCH_TENANT_LIST = createType('FETCH_TENANT_LIST')
export const TENANT_LIST_FETCHED = createType('TENANT_LIST_FETCHED')
export const SHOW_INFO_DIALOG = createType('SHOW_INFO_DIALOG')
export const HIDE_INFO_DIALOG = createType('HIDE_INFO_DIALOG')
export const CREATE_TENANT = createType('CREATE_TENANT')
export const TENANT_CREATED = createType('TENANT_CREATED')
export const UPDATE_TENANT = createType('UPDATE_TENANT')
export const TENANT_UPDATED = createType('TENANT_UPDATED')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const SHOW_TENANT_BALANCE_DIALOG = createType('SHOW_TENANT_BALANCE_DIALOG')
export const SHOW_TENANT_CREDIT_DIALOG = createType('SHOW_TENANT_CREDIT_DIALOG')
export const SHOW_RECHARGE_BALANCE_DIALOG = createType('SHOW_RECHARGE_BALANCE_DIALOG')
export const FETCH_STAFF_CONVS = createType('FETCH_STAFF_CONVS')
export const STAFF_CONVS_FETCHED = createType('STAFF_CONVS_FETCHED')
export const REGISTER_TENANT = createType('REGISTER_TENANT')

